<template>
  <div
    v-click-outside="$_onDropdownClose"
    class="lv-dropdown-menu-multi-layer"
  >
    <div
      class="lv-dropdown-menu-multi-layer__button"
      :class="[{shrink: isShrink, outline: outline }]"
      :style="{'min-width': minWidth}"
      @click="$_onToggleDropdownMenu()"
    >
      <button>
        <p>{{ _selectedItemText }}</p>
      </button>
      <i
        class="icon"
        :class="[{
          [`${icon}`]: icon,
          show: isShow.menu,
        }]"
      />
    </div>
    <div
      class="lv-dropdown-menu-multi-layer__menu"
      :class="{show: isShow.menu}"
    >
      <perfect-scrollbar class="ps dropdown-scrollable-content">
        <LvInfoMultiLayer
          :disable="disable"
          :items="items"
          :value="value"
          @click="$_onItemClick($event)"
        />
      </perfect-scrollbar>
    </div>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";
export default {
  name: "LvDropdownMenuMultiLayer",
  directives: {
    ClickOutside,
  },
  props: {
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {
      type: [Number, String],
    },
    placeholder: {
      type: String,
      default: "",
    },
    isShrink: {
      type: Boolean,
      default: false,
    },
    outline: {
      type: Boolean,
      default: true,
    },
    icon: {
      type: String,
      default: "icon-chevron-up",
    },
    minWidth: {
      type: String,
    },
    disable: {
      type: Boolean,
      default: false,
    }
  },
  data: () => ({
    isShow: {
      menu: false
    }
  }),
  computed: {
    _selectedItemText(){
      if (!this.items) return '';
      let resultText = '';
      if (this.value) {
        const _selectedItemText = this.$_getSelectedItemText(this.items, this.value);
        resultText = _selectedItemText;
      } else if (this.placeholder) {
        resultText = this.placeholder;
      } else {
        resultText = this.items.map(item => item.name).join(',');
      }
      return this.$t(resultText);
    }
  },
  methods: {
    $_onDropdownClose() {
      this.isShow.menu = false;
    },
    $_onToggleDropdownMenu() {
      this.isShow.menu = !this.isShow.menu;
    },
    $_onItemClick(item) {
      this.$emit("click", item);
      this.isShow.menu = false;
    },
    $_getSelectedItemText(items, value) {
      let resultText = ""
      items.forEach((item) => {
        if (item.id == value) {
          resultText = item.name
          return
        } else if (item.items.length) {
          const _resultText = this.$_getSelectedItemText(item.items, value)
          if (_resultText !== "") {
            resultText = _resultText
            return
          }
        }
      })
      return resultText
    }
  },
};
</script>